import PropTypes from 'prop-types';

export default function StrategyDiagnostics({ diagnostics = [] }) {
  const items = diagnostics?.length
    ? diagnostics
    : [
        { code: 'open_position_lock', active: false, detail: 'No open position lock detected' },
        { code: 'dedupe_window', active: false, detail: 'No dedupe window blocking trades' },
      ];

  return (
    <div className="rounded-2xl border border-gray-800 bg-gray-900/70 p-4" data-testid="strategy-diagnostics">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-[0.65rem] uppercase tracking-wide text-gray-500">Readiness</p>
          <h3 className="text-lg font-semibold text-white">Why No Trades?</h3>
        </div>
      </div>
      <ul className="space-y-2 text-sm">
        {items.map((item) => (
          <li
            key={item.code}
            className="flex items-start gap-2 rounded-lg border border-gray-800 bg-gray-900/50 p-2"
          >
            <span className={`mt-0.5 h-2.5 w-2.5 rounded-full ${item.active ? 'bg-amber-400' : 'bg-green-500'}`} />
            <div>
              <div className="font-semibold text-gray-200">{item.code.replace(/_/g, ' ')}</div>
              <div className="text-gray-400 text-xs">{item.detail || 'No detail available'}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

StrategyDiagnostics.propTypes = {
  diagnostics: PropTypes.arrayOf(PropTypes.object),
};
